var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 19.4853V21H5.01472C6.24097 21 6.8541 21 7.40541 20.7716C7.95673 20.5433 8.39027 20.1097 9.25736 19.2426L19.1213 9.37868C20.0039 8.49612 20.4451 8.05483 20.4939 7.51325C20.502 7.42372 20.502 7.33364 20.4939 7.24411C20.4451 6.70253 20.0039 6.26124 19.1213 5.37868C18.2387 4.49612 17.7974 4.05483 17.2559 4.00605C17.1663 3.99798 17.0763 3.99798 16.9867 4.00605C16.4451 4.05483 16.0039 4.49612 15.1213 5.37868L5.25736 15.2426C4.39027 16.1097 3.95673 16.5433 3.72836 17.0946C3.5 17.6459 3.5 18.259 3.5 19.4853Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7L17.5 11",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditThin);
export default __webpack_public_path__ + "static/media/edit-thin.ef46ca10153e18e033c4985343c09872.svg";
export { ForwardRef as ReactComponent };